import React from "react";

const HtmlContent = ({ htmlString, className, tableHeader }) => {
  return (
    <div
      className={className || tableHeader ? `htmlContent` : ""}
      dangerouslySetInnerHTML={{ __html: htmlString }}
    />
  );
};

const MarkDownContent = ({ htmlContent, className, tableHeader = false }) => {
  return (
    <div className={className ? `model-section overflow-auto` : ""}>
      <style>
        {`
                    .htmlContent {
                        display: flex;
                        flex-direction: column;
                        padding: 0px 10px 10px 10px !important;
                        border: none !important;
                    }
                    .htmlContent table {
                        width: 100% !important;
                         height: auto !important;
                        text-align: center !important;
                        border-collapse: collapse !important;
                        display: block !important; 
                        overflow-x: auto !important; 
                    }
                    .htmlContent table th {
                        white-space: nowrap !important;
                    }
                   .htmlContent ol, .htmlContent ul {
                       list-style: revert !important;
                        list-style-type: revert !important;
                        margin: revert;
                        padding: revert;
                    }
                    .htmlContent table th, .htmlContent table td {
                        padding: 10px !important;
                        border: 1px solid #ddd !important;
                    }
                    .htmlContent h1 {
                        font-size: 28px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent h2 {
                        font-size: 24px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent h3 {
                        font-size: 20px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent h4 {
                        font-size: 16px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent h5 {
                        font-size: 12px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent h6 {
                        font-size: 8px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContent p {
                        margin: revert;
                    }
                    textarea {
                        width: 100% !important;
                    }
                `}
      </style>
      <HtmlContent
        htmlString={htmlContent}
        className={className}
        tableHeader={tableHeader}
      />
    </div>
  );
};
export default MarkDownContent;
